export type ResampleSize = number;
export type ScoutAxis = 'coronal' | 'sagittal';

/** Minimum allowed slice thickness in mm. */
export const MIN_THICKNESS_MM = 1.0;
/** Maximum allowed slice thickness in mm. */
export const MAX_THICKNESS_MM = 5.0;
/** Minimum allowed field of view in mm. */
export const MIN_FOV_MM = 50;
/** Minimum number of slices in the output volume. */
export const MIN_SLICES = 3;
/** Maximum scout projection display size in pixels. */
export const PROJECTION_MAX_SIZE = 480;

const SLICE_THICKNESS_REGEX = /^\d+(\.\d{1,2})?$/;

/**
 * Validate a user-entered slice thickness string.
 * Returns an error message or null when valid.
 */
export function validateSliceThickness(value: string): string | null {
    if (!value.trim()) {
        return 'Required';
    }
    if (!SLICE_THICKNESS_REGEX.test(value) || value.endsWith('.')) {
        return 'Max two decimals allowed';
    }
    const num = Number(value);
    if (isNaN(num)) {
        return 'Invalid number';
    }
    if (num < MIN_THICKNESS_MM || num > MAX_THICKNESS_MM) {
        return `Value must be between ${MIN_THICKNESS_MM} and ${MAX_THICKNESS_MM} mm`;
    }
    return null;
}
